import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  const urlParams = new URLSearchParams(window.location.search)
  const animationsEnabled = node.getAttribute('data-animations-enabled') == 'true'
  const animationDelay = node.getAttribute('data-animate-delay')
  const closeButton = $(node).find('[data-close]')
  const startDate = node.getAttribute('data-schedule-start') ? new Date(node.getAttribute('data-schedule-start')) : null
  const endDate = node.getAttribute('data-schedule-end') ? new Date(node.getAttribute('data-schedule-end')) : null
  const currentDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }))
  const pstCurrentDate = new Date(currentDate)
  const sessionAlertBannerHidden = sessionStorage.getItem('alertBannerHidden') || 'false'
  const sessionDiscountApplied = sessionStorage.getItem('discountApplied') || 'false'
  const autoDiscount = node.getAttribute('data-auto-discount')
  const discountText = node.getAttribute('data-discount-text')
  const appliedDiscountText = node.getAttribute('data-applied-discount-text')
  const discountLinks = $(node).findEls('.js-discount-text')

  if (sessionAlertBannerHidden != 'true') {
    const urlParams = new URLSearchParams(window.location.search)
    const utmAffilitate = urlParams.get('irpid')

    if (
      (!startDate && !endDate) ||
      (startDate && !endDate && currentDate > startDate) ||
      (!startDate && endDate && currentDate < endDate) ||
      (startDate && endDate && currentDate > startDate && currentDate < endDate)
    ) {
      if (!utmAffilitate) {
        showAlert()
      }
    }
  }

  if (discountLinks.length > 0) {
    if (urlParams.get('discount') === autoDiscount || sessionDiscountApplied == 'true') {
      discountLinks.forEach((link) => {
        link.innerText = appliedDiscountText
      })
      sessionStorage.setItem('discountApplied', true)
    } else {
      discountLinks.forEach((link) => {
        link.innerText = discountText
        link.ariaDisabled = 'false'
        link.setAttribute('tabindex', '0')
        $(link).on('click', function () {
          window.MicroBus.emit('igEvents:push', { event: 'Banner Auto Apply Discount - Clicked' })
          if (window?.gtag) {
            window.gtag('event', 'Banner Auto Apply Discount - Clicked', {})
          }
          window.location.href = $(link).attr('data-discount-url') || '#'
        })
      })
    }
  }

  function showAlert() {
    if (animationsEnabled) {
      setTimeout(() => {
        node.setAttribute('aria-hidden', 'false')
      }, animationDelay)
    } else {
      node.setAttribute('aria-hidden', 'false')
    }
  }

  function hideAlert() {
    node.setAttribute('aria-hidden', 'true')
    sessionStorage.setItem('alertBannerHidden', true)
    if (window?.gtag) {
      gtag('event', 'Alert Banner Closed', {})
    }
  }

  //listeners
  closeButton.on('click', () => {
    hideAlert()
  })
})
